import React from 'react';
import TrimCardImage from '../trims/TrimCardImage/TrimCardImage';
import PriceWithDisclaimer from '../priceWithDisclaimer/PriceWithDisclaimer';
import Radio from 'core/controls/radio/Radio';
import GridCard, {
  GridCardPrimarySection,
  GridCardSecondarySection,
} from '../../../components/cards/gridCard/GridCard';
import OptionLinks from '../optionLinks/OptionLinks';
import { combineClassNames } from '../../../../core/css';

const BodyCard = (props) => {
  const {
    disclaimer,
    checked,
    onChange,
    option,
    bodyIndex,
    isUpdating,
    isUpdatingOption,
    wait,
    animation,
    cgiImageUrl,
    primaryRef,
    primaryDivHeight,
  } = props;
  const ANALYTICS_KEY = 'configuration';
  const { description, msrp, message, attributes } = option;

  const bodyAttributes = attributes.map((attribute) => (
    <div className="body-card__attribute" key={attribute.label}>
      <span className="body-card__item-label">{attribute.label}:</span>{' '}
      <span className="body-card__item-value">{attribute.value}</span>
    </div>
  ));

  const onClick = () => {
    if (!checked) {
      onChange(option);
    }
  };

  return (
    <GridCard
      checked={checked}
      onClick={onClick}
      isUpdating={isUpdating}
      isUpdatingOption={isUpdatingOption}
      wait={wait}
      animation={animation}>
      <div
        className={combineClassNames('body-card__container', 'stat-wrapper')}
        data-dtm={ANALYTICS_KEY}
        data-dtm2={description}>
        <TrimCardImage cgi={cgiImageUrl} trimName={option.trimName} />
        <GridCardPrimarySection
          primaryRef={primaryRef}
          height={primaryDivHeight}>
          <Radio
            className="body-card__body-type-selector control--top option option--tf"
            id={`body__${bodyIndex}`}
            analyticsKey={ANALYTICS_KEY}
            analyticsKey2={description}
            checked={checked}>
            <span className="option__body-type">{description}</span>
          </Radio>
          <OptionLinks
            options={option}
            className="option-links-container--bottom"
          />
        </GridCardPrimarySection>
        <GridCardSecondarySection
          className={checked ? 'body-card__attributes--checked' : ''}>
          {bodyAttributes && (
            <div className="body-card__attributes">{bodyAttributes}</div>
          )}
          {(msrp || message) && (
            <div className="option__disclaimer">
              <PriceWithDisclaimer
                value={msrp}
                message={message}
                disclaimer={disclaimer}
                useModal
              />
            </div>
          )}
        </GridCardSecondarySection>
      </div>
    </GridCard>
  );
};

export default BodyCard;
